<div class="logo">
  @if ((hasCurrentApp$ | async) === true) {
    <a [href]="(currentApp$ | async)?.serviceUri">
      <img class="logo__img" [src]="(currentApp$ | async)?.logoUri" [alt]="(currentApp$ | async)?.name" />
    </a>
  }
  @if ((hasCurrentApp$ | async) === false) {
    <a routerLink="/">
      <img
        class="logo__img"
        src="https://storage.googleapis.com/wizbii/static-assets-v4/logos/SVG/RGB/WIZBII_Account.svg"
        alt="Logo WIZBII Account"
      />
    </a>
  }
</div>
